import React, { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown, Calendar, Sparkles } from 'lucide-react';
import { collection, onSnapshot, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';

const MetalPriceTracker = () => {
  const [prices, setPrices] = useState({
    gold: { price: 0, change: 0, isUp: false },
    silver: { price: 0, change: 0, isUp: false }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const pricesQuery = query(
      collection(db, 'metalPrices'),
      orderBy('date', 'desc'),
      limit(2)
    );

    const unsubscribe = onSnapshot(pricesQuery, (snapshot) => {
      const priceData = snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }));

      if (priceData.length >= 2) {
        const latest = priceData[0];
        const previous = priceData[1];

        setPrices({
          gold: {
            price: latest.goldPrice,
            change: latest.goldPrice - previous.goldPrice,
            isUp: latest.goldPrice > previous.goldPrice
          },
          silver: {
            price: latest.silverPrice,
            change: latest.silverPrice - previous.silverPrice,
            isUp: latest.silverPrice > previous.silverPrice
          }
        });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const promoMessages = [
    { metal: 'gold', message: "Invest in Timeless Elegance" },
    { metal: 'silver', message: "Pure Silver, Eternal Beauty" },
    { metal: 'gold', message: "Crafted for Generations" },
    { metal: 'silver', message: "Artisanal Silver Treasures" }
  ];

  const PriceItem = ({ metal, data }) => (
    <div className="inline-flex items-center px-6 py-2 border-r border-purple-100 last:border-r-0">
      <div className={`p-1.5 rounded-full mr-2 ${
        metal === 'gold' 
          ? 'bg-amber-100 text-amber-600' 
          : 'bg-purple-100 text-purple-600'
      }`}>
        <Sparkles className="w-4 h-4" />
      </div>
      <span className={`font-medium uppercase text-sm mr-2 ${
        metal === 'gold' 
          ? 'text-amber-700' 
          : 'text-purple-700'
      }`}>
        {metal}
      </span>
      <span className="font-semibold text-purple-900 mr-2">
        ₹{data.price.toLocaleString('en-IN')}
      </span>
      <div className={`flex items-center ${data.isUp ? 'text-green-600' : 'text-red-600'}`}>
        {data.isUp ? (
          <TrendingUp className="w-3 h-3 mr-1" />
        ) : (
          <TrendingDown className="w-3 h-3 mr-1" />
        )}
        <span className="text-sm font-medium">
          ₹{Math.abs(data.change).toLocaleString('en-IN')}
        </span>
      </div>
    </div>
  );

  const PromoMessage = ({ metal, message }) => (
    <div className="inline-flex items-center px-8 py-2 border-r border-purple-100 last:border-r-0">
      <div className={`p-1.5 rounded-full mr-3 ${
        metal === 'gold' 
          ? 'bg-amber-100 text-amber-600' 
          : 'bg-purple-100 text-purple-600'
      }`}>
        <Sparkles className="w-4 h-4" />
      </div>
      <span className={`text-sm font-serif italic ${
        metal === 'gold' 
          ? 'text-amber-700' 
          : 'text-purple-700'
      }`}>
        {message}
      </span>
    </div>
  );

  return (
    <div className="w-full bg-white/95 backdrop-blur-sm border-y border-purple-100 shadow-sm">
      <div className="container mx-auto overflow-hidden py-1.5">
        <div className="flex animate-marquee whitespace-nowrap">
          {/* Prices and promo messages alternating */}
          <PriceItem metal="gold" data={prices.gold} />
          <PromoMessage {...promoMessages[0]} />
          <PriceItem metal="silver" data={prices.silver} />
          <PromoMessage {...promoMessages[1]} />
          <PriceItem metal="gold" data={prices.gold} />
          <PromoMessage {...promoMessages[2]} />
          <PriceItem metal="silver" data={prices.silver} />
          <PromoMessage {...promoMessages[3]} />
          <PriceItem metal="gold" data={prices.gold} />
          <PromoMessage {...promoMessages[0]} />
          <PriceItem metal="silver" data={prices.silver} />
          <PromoMessage {...promoMessages[1]} />
          <PriceItem metal="gold" data={prices.gold} />
          <PromoMessage {...promoMessages[2]} />
          <PriceItem metal="silver" data={prices.silver} />
          <PromoMessage {...promoMessages[3]} />
        </div>
      </div>
      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default MetalPriceTracker;